<template>
  <v-row>
    <v-col>
      <v-expand-transition>
        <v-autocomplete
          v-if="!pending"
          :items="allPlaces"
          item-value="short_name"
          :item-text="item => `(${item.short_name}) ${item.stop_name}`"
          :filter="
            (item, query) =>
              item.short_name.toLowerCase().includes(query.toLowerCase()) ||
              item.stop_name.toLowerCase().includes(query.toLowerCase())
          "
          :rules="[required]"
          :loading="pending"
          :disabled="pending"
          chips
          placeholder="Välj platser"
          outlined
          label="Platser"
          v-model="places"
          multiple
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="remove(data.item)"
            >
              {{ data.item.stop_name }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-expand-transition>
    </v-col>
  </v-row>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import { validTime, required } from '@/common/validationRules'

export default {
  name: 'RejectedStopLocationFields',

  data: () => ({
    required,
    validTime,
    time: null
  }),

  computed: {
    pending: get('rejectedStop/pending@searchTrain'),
    stops: get('event/stops'),
    model: get('rejectedStop/model'),
    places: sync('rejectedStop/model@places'),
    advertisedPlaces: get('trainDeviation/advertisedPlaces'),

    allPlaces() {
      return this.model.type === 'RST' && this.advertisedPlaces.length
        ? this.advertisedPlaces
        : this.stops
    }
  },

  methods: {
    remove(item) {
      const index = this.places.indexOf(item.short_name)
      if (index >= 0) this.places.splice(index, 1)
    }
  }
}
</script>

<style>
/* Fixes autocomplete placeholder not show bug */
.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  max-height: inherit;
}
</style>
